import { UserClassModel } from '@/models/class/class';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { journeyAPI } from '@/providers/apis/journey/journey';
import { MilestoneLessonsModel, MilestoneModel } from '@/models/journey/journey';

@Component({
    name: 'subject-journey-panel',
})

export default class SubjectJourneyComponent extends Vue {

    // -----------------------------------------------------
    // Properties

    @Prop({default: []})
    private activeClasses!: UserClassModel[];

    @Prop()
    private userId!: string;

    @Prop()
    private subject: any;

    private journeyList: any = [];

    private activeJourney: any = {};

    // -----------------------------------------------------
    // Hooks

    private created() {
        this.loadData();
    }

    // -----------------------------------------------------
    // Actions

    private onSelectJourney(journey: any) {
        this.activeJourney = journey;
        this.fetchMilestones(journey);
    }

    private onSelectMilestone(milestone: any) {
        this.fetchMilestoneLessons(milestone);
    }


    // -----------------------------------------------------
    // Methods

    private loadData() {
        const activeClasses = [...this.activeClasses];
        activeClasses.forEach((classDetail) => {
            this.journeyList.push(classDetail);
        });
        this.activeJourney = this.journeyList ? this.journeyList[0] : null;
        this.fetchMilestones(this.activeJourney);
    }


    private fetchMilestones(classDetail: UserClassModel) {
        const params = {
            courseId: classDetail.courseId,
            fwCode: classDetail.framework || 'CCSS',
            queryParams: {
                class_id: classDetail.id,
                user_id: this.userId,
            },
        };
        if (!classDetail.milestones) {
            journeyAPI.fetchClassMilestones(params).then((milestones) => {
                this.$set(classDetail, 'milestones', milestones);
             });
        }
    }

    private fetchMilestoneLessons(milestone: MilestoneModel ) {
        const activeJourney = this.activeJourney;
        const params = {
            courseId: activeJourney.courseId,
            milestoneId: milestone.milestoneId,
        };
        if (!milestone.domains) {
            journeyAPI.fetchMilestoneDetails(params).then((lessons) => {
                const filterDomains = lessons.filter((item, index, self) =>
                    self.findIndex((selfItem) => selfItem.domainCode === item.domainCode) === index);
                this.$set(milestone, 'domains', filterDomains);
                this.$set(milestone, 'lessons', lessons);
             });
        }
    }

}
